import React from 'react';
import MenuPainel from '../components/MenuPainel';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import { connect } from 'react-redux';
import Alert from '../components/Alert';
import { alertActions } from '../actions';
import { ResponsavelFinanceiro } from '../components/ResponsavelFinanceiro/';
import GlobalStyle from '../styles/globalStyle';
import { CssBaseline } from '@material-ui/core';
class AdmResponsavelFinanceiro extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.dispatch(alertActions.clear());
  }
  render() {
    const { message, type, open } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel stepper='Responsável Financeiro'>
          <Alert
            open={open}
            type={type}
            message={message}
            onClose={() => this.handleClose(type, message)}
          />
          <PaperForm
            margin={'20px 0'}
            widthGrid={'90%'}
            width={'100%'}
            elevation={24}
            componente={<ResponsavelFinanceiro />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { message, type, open } = state.alert;
  return {
    message,
    type,
    open,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(
  AdmResponsavelFinanceiro
);
export { connectedRegisterPage as AdmResponsavelFinanceiro };
